/**
 * Working preview host for the reusable IdentityResolution component. Its
 * real host is New Booking (scheduling build). Picking a match opens the
 * record; inline first-contact capture creates the minimal Patient (Guest).
 */

import { useNavigate } from '@tanstack/react-router';
import { useIntl } from 'react-intl';
import a from '../access/access.module.css';
import { Notice } from '@/ui/kit';
import { IdentityResolution } from './IdentityResolution';

export function ResolutionPreviewPage() {
  const intl = useIntl();
  const navigate = useNavigate();
  return (
    <div style={{ maxInlineSize: 720, display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div className={a.pageHead} style={{ marginBlockEnd: 0 }}>
        <h1 className={a.pageTitle}>{intl.formatMessage({ id: 'res.title' })}</h1>
      </div>
      <Notice kind="info">{intl.formatMessage({ id: 'res.hostNote' })}</Notice>
      <IdentityResolution
        onPick={(p) => void navigate({ to: '/patients/$patientId', params: { patientId: p.id } })}
      />
    </div>
  );
}
